var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.41 41.363v46.59H64.82V67.805a3.2 3.2 0 00-3.199-3.2H39.125a3.2 3.2 0 00-3.2 3.2v20.148h-17.48v-46.59h-6.398v49.79a3.197 3.197 0 003.2 3.195h23.878c1.766 0 3.2-1.43 3.2-3.196V71.004h16.097v20.148a3.197 3.197 0 003.2 3.196h23.987a3.194 3.194 0 003.196-3.196V41.363zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.988 49.902L52.613 6.516a3.203 3.203 0 00-4.351-.024L1.035 49.882a3.199 3.199 0 104.328 4.712L50.406 13.21l44.211 41.363a3.197 3.197 0 004.52-.148 3.202 3.202 0 00-.149-4.524zm0 0"
  })));
};
export default SvgHome;